<script lang="ts">
    import {onMount} from "svelte";
    import FontAwesomeView from "../common/Image/FontAwesomeView.svelte";
    import DynamicAnkerView from "../common/Link/DynamicAnkerView.svelte";

    export let pageTrailMap;

    onMount(() => {
    });


</script>

{#if pageTrailMap != null}
    <div class="page-trail-view">
        {#each Object.entries(pageTrailMap) as [name, url], index}
            {#if index !== 0}
                <div>
                    <FontAwesomeView icon="chevron-right"/>
                </div>
            {/if}

            <div class="name">
                <DynamicAnkerView href={url} isOtherTab={true}>
                    {name}
                </DynamicAnkerView>
            </div>

        {/each}
    </div>
{/if}

<style lang="scss">
    .template-view {

    }
</style>